'use client'

import React from 'react'

type Props = {
    topRadius: number
    bottomRadius: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function ConeFrustumChart({ topRadius, bottomRadius, height }: Props) {
    const maxDim = Math.max(topRadius * 2, bottomRadius * 2, height, 0.0001)
    const scale = 130 / maxDim
    const rx1 = Math.max(topRadius * scale, 18)
    const rx2 = Math.max(bottomRadius * scale, 18)
    const ry1 = rx1 * 0.3
    const ry2 = rx2 * 0.3
    const h = Math.max(height * scale, 50)

    const cx = WIDTH / 2
    const bottomY = (HEIGHT + h) / 2
    const topY = bottomY - h

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={`${cx - rx2},${bottomY} ${cx - rx1},${topY} ${cx + rx1},${topY} ${cx + rx2},${bottomY}`} fill="#2563eb" opacity={0.18} />
            <line x1={cx - rx2} y1={bottomY} x2={cx - rx1} y2={topY} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx + rx2} y1={bottomY} x2={cx + rx1} y2={topY} stroke="#2563eb" strokeWidth={2} />
            <ellipse cx={cx} cy={bottomY} rx={rx2} ry={ry2} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            <ellipse cx={cx} cy={topY} rx={rx1} ry={ry1} fill="#eff6ff" stroke="#2563eb" strokeWidth={2} />

            <line x1={cx} y1={topY} x2={cx + rx1} y2={topY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + rx1 / 2} y={topY - 6} fontSize={11} textAnchor="middle" fill="#dc2626">r₁ = {topRadius.toFixed(2)}</text>

            <line x1={cx} y1={bottomY} x2={cx + rx2} y2={bottomY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + rx2 / 2} y={bottomY + 18} fontSize={11} textAnchor="middle" fill="#dc2626">r₂ = {bottomRadius.toFixed(2)}</text>

            <line x1={cx - Math.max(rx1, rx2) - 16} y1={topY} x2={cx - Math.max(rx1, rx2) - 16} y2={bottomY} stroke="#16a34a" strokeWidth={1.5} />
            <text x={cx - Math.max(rx1, rx2) - 22} y={(topY + bottomY) / 2} fontSize={11} textAnchor="end" fill="#16a34a">h = {height.toFixed(2)}</text>
        </svg>
    )
}
